import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import AuthService from "./services/auth.service";
import { PrivateAppRouter } from "./routes/PrivateAppRoutes"
import { PublicAppRouter } from "./routes/PublicAppRoutes";

import "bootstrap/dist/css/bootstrap.min.css";

function App () {
  const isAuthenticated = AuthService.isAuthenticated();
  
  return (
    <BrowserRouter>
      <Routes>
        {
          isAuthenticated === true
          ? < Route path="/*" element={<PrivateAppRouter/>} />
          : <Route path="/*" element={ <PublicAppRouter />}  />
        }
      </Routes>
    </BrowserRouter>
  )
}

export default App;